import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

const DeleteDialog = ({ 
  open, 
  onClose, 
  onConfirm, 
  title = "Are you sure?", 
  message = "Do you really want to delete this item? This action cannot be undone.", 
  confirmColor = "error",
  cancelColor = "primary",
  size = "medium"
}) => {
  const theme = useTheme();
  const { i18n } = useTranslation();
  const isRTL = i18n.language === "ar";

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      sx={{
        "& .MuiDialog-paper": {
          width: size === "small" ? "300px" : size === "large" ? "500px" : "400px",
          padding: "20px",
          borderRadius: "12px",
          backgroundColor: theme.palette.background.default,
          color: theme.palette.text.primary,
          direction: isRTL ? "rtl" : "ltr",
        }
      }}
    >
      <DialogTitle
        sx={{
          fontSize: "22px",
          fontWeight: "bold",
          textAlign: "center",
          color: theme.palette.warning.main,
        }}
      >
        {title}
      </DialogTitle>

      <DialogContent>
        <DialogContentText
          sx={{
            fontSize: "16px",
            textAlign: "center",
            color: theme.palette.text.secondary,
          }}
        >
          {message}
        </DialogContentText>
      </DialogContent>

      <DialogActions
        sx={{
          flexDirection: isRTL ? "row-reverse" : "row",
          justifyContent: "center",
          gap: 2,
        }}
      >
        <Button onClick={onClose} color={cancelColor}
          sx={{
            backgroundColor: theme.palette.success.main,
            color: "#fff",
            padding: "8px 20px",
            fontSize: "14px",
            borderRadius: "8px",
            "&:hover": { backgroundColor: theme.palette.success.dark }
          }}
        >
          {isRTL ? "إلغاء" : "Cancel"}
        </Button>

        <Button onClick={onConfirm} color={confirmColor}
          sx={{
            backgroundColor: theme.palette.error.main,
            color: "#fff",
            padding: "8px 20px",
            fontSize: "14px",
            borderRadius: "8px",
            "&:hover": { backgroundColor: theme.palette.error.dark }
          }}
        >
          {isRTL ? "تأكيد" : "Confirm"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDialog;
